import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

import { Button } from '@basic';
import { UIPaths } from '@consts';
import ArrowRightIcon from 'components/icons/ArrowRightIcon';
import PlaceholderCatIcon from './PlaceholderCatIcon';
import PlaceholderContainer from './PlaceholderContainer';
import PlaceholderHeader from './PlaceholderHeader';
import PlaceholderText from './PlaceholderText';

export default function ErrorUnexpectedPlaceholder({
  redirectToHome = false
}: {
  redirectToHome?: boolean;
}) {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <PlaceholderContainer className='h-dvh'>
      <PlaceholderCatIcon />
      <PlaceholderHeader text={t('components.errorUnexpectedPlaceholder.header')} />
      {redirectToHome ? (
        <>
          <PlaceholderText text={t('components.errorUnexpectedPlaceholder.backToHome.text')} />
          <Button size='large' type='primary' onClick={() => router.push(UIPaths.home())}>
            <div className='flex flex-row items-center justify-center gap-xs'>
              <div>{t('components.errorUnexpectedPlaceholder.backToHome.buttonText')}</div>
            </div>
            <ArrowRightIcon size={24} />
          </Button>
        </>
      ) : (
        <>
          <PlaceholderText text={t('components.errorUnexpectedPlaceholder.reload.text')} />
          <Button size='large' type='tertiary' onClick={() => router.reload()}>
            <div className='flex flex-row items-center justify-center gap-xs'>
              <div>{t('components.errorUnexpectedPlaceholder.reload.buttonText')}</div>
            </div>
          </Button>
        </>
      )}
    </PlaceholderContainer>
  );
}
